export default { sha: 'a80e33a380520d44425cbc72ace5f0d0ba1565b7', buildNumber: 'undefined' }
